var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.5386 11.1372H13.6918L16.9903 21.2876L20.2888 11.1372H23.4609L18.7482 24.0419H15.2502L10.5386 11.1372Z","fill":"black","key":0}),React.createElement("path",{"d":"M17 34C7.62639 34 0 26.3736 0 17C0 7.62639 7.62639 0 17 0C26.3736 0 34 7.62639 34 17C34 26.3736 26.3736 34 17 34ZM17 2.125C8.7975 2.125 2.125 8.7975 2.125 17C2.125 25.2025 8.7975 31.875 17 31.875C25.2025 31.875 31.875 25.2025 31.875 17C31.875 8.7975 25.2025 2.125 17 2.125Z","fill":"black","key":1})]);
}

LogoIcon.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
